<template>
    <div class="preview-image-message">
        <PreviewAvatar />
        <div class="image-container">
            <img :src="imageUrl" alt="Preview Image" />
        </div>
    </div>
</template>

<script>
import PreviewAvatar from '../PreviewAvatar.vue';

export default {
  name: 'ImageMessagePreview',
  props: {
    imageUrl: {
      type: String,
      required: true,
      default: '',
    }
  },
  components: {
    PreviewAvatar
  },
};
</script>

<style lang="scss" scoped>
.preview-image-message{
    padding-right: 60px;
    .image-container{
        position: relative;
        top: -14px;
        padding-left: 40px;
        width: 200px;
        height: auto;
        img{
            width: 100%;
            height: auto;
            border-radius: 8px;
        }
    }
}
</style>
